<template>
  <!-- 左侧菜单 -->
  <el-aside class="menu" :class="isCollapse?'menuCollapse':''">
    <el-menu default-active="1" :collapse="isCollapse" :collapse-transition="false">
      <el-submenu index="1">
        <template slot="title">
          <i class="el-icon-menu"></i>
          <span>菜单管理</span>
        </template>
        <router-link to="/menu">
          <el-menu-item index="1-1">
            <i class="el-icon-tickets"/>
            <span>Table表格管理</span>
          </el-menu-item>
        </router-link>
        <router-link to="/form">
          <el-menu-item index="1-2">
            <i class="el-icon-tickets"/>
            <span>表单管理</span>
          </el-menu-item>
        </router-link>
        <router-link to="/login">
          <el-menu-item index="1-3">
            <i class="el-icon-tickets"/>
            <span>登录页面</span>
          </el-menu-item>
        </router-link>
      </el-submenu>

      <el-submenu index="2">
        <template slot="title">
          <i class="el-icon-printer"></i>
          <span>数据管理</span>
        </template>
        <router-link to="/addarticle">
          <el-menu-item index="2-1">
            <i class="el-icon-tickets"/>
            <span>添加文章</span>
          </el-menu-item>
        </router-link>
        <router-link to="/upload">
          <el-menu-item index="2-1">
            <i class="el-icon-tickets"/>
            <span>添加上传</span>
          </el-menu-item>
        </router-link>
      </el-submenu>

      <el-menu-item index="3">
        <i class="el-icon-setting"/>
        <span>基础设置</span>
      </el-menu-item>
    </el-menu>
  </el-aside>
</template>

<script>
export default {
  data() {
    return {
      isCollapse: false
    };
  },
  methods: {
    menuToggle() {
      this.isCollapse = !this.isCollapse;
    }
  }
};
</script>